import React, { useState, useEffect } from "react";
import axios from "axios";

const ResetPassword = () => {
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const parts = window.location.pathname.split("/");
    const foundToken = parts[parts.length - 1];
    if (foundToken && foundToken.length >= 20) setToken(foundToken);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || password !== confirmPassword) {
      setMessage("❌ Email required and passwords must match!");
      return;
    }
    if (!token.trim()) {
      setMessage("❌ Please enter the token from your email.");
      return;
    }

    try {
      setLoading(true);
      setMessage("");

      const payload = {
        email: email.trim().toLowerCase(),
        token: token.trim(),
        password,
      };

      const res = await axios.post("/api/auth/reset-password", payload);
      if (res.data.message && res.data.message.toLowerCase().includes("successful")) {
        setMessage("✅ Password reset successful! Redirecting...");
        setTimeout(() => (window.location.href = "/"), 2000);
      } else {
        setMessage("⚠️ Something went wrong. Try again.");
      }
    } catch (err) {
      const msg = err?.response?.data?.message || "❌ Invalid or expired link.";
      setMessage(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.header}>Reset Your Password</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="Enter token (from email)"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="Enter new password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={styles.input}
            required
          />
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </button>
          {message && <p style={styles.message}>{message}</p>}
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#eef2f7",
  },
  card: {
    background: "#fff",
    padding: "2rem",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "420px",
    textAlign: "center",
  },
  header: { marginBottom: "1.5rem", color: "#222" },
  form: { display: "flex", flexDirection: "column" },
  input: {
    padding: "10px",
    margin: "8px 0",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  button: {
    background: "#007bff",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "1rem",
    marginTop: "10px",
  },
  message: { marginTop: "15px", color: "#333", fontWeight: 500 },
};
